import React from 'react';
import PropTypes from 'prop-types';
import VirtualList from 'react-tiny-virtual-list';

const DefaultItemHeight = 40;

export default class CustomMenuList extends React.Component {
  static propTypes = {
    options   : PropTypes.array.isRequired,
    children  : PropTypes.node.isRequired,
    maxHeight : PropTypes.number.isRequired,
    getValue  : PropTypes.func.isRequired
  }

  getItemSize = (index) => {
    // TODO Use this function as a truncation function when a select option is too long
    //const { children } = this.props;
    //const child = children[index];
    return DefaultItemHeight;
  };

  renderItem = (props) => {
    const { reorderedChildren } = this;
    if (Array.isArray(reorderedChildren) && reorderedChildren[props.index]) {
      const child = reorderedChildren[props.index];
      return (
        <li style={props.style} key={props.index} title={child.props && child.props.data && child.props.data.label}>
          {child}
        </li>
      );
    }
    return (
      <li
        key={props.index}
        style={{ whiteSpace: 'none' }}
        className="react-virtualized-menu-placeholder"
      >
        {this.props.children && this.props.children.props && this.props.children.props.children}
      </li>
    );
  }

  render() {
    const { children, maxHeight, getValue } = this.props;
    const selected = getValue() || [];
    const selectedValueSet = new Set((Array.isArray(selected) ? selected : [selected]).map(s => (s && s.value !== undefined) ? s.value : s));
    const childrenOptions = React.Children.toArray(children);
    const selectedChildren = [];
    const otherChildren = [];
    childrenOptions.forEach((child) => {
      const data = child && child.props && child.props.data;
      const val = data && data.value !== undefined ? data.value : data;
      if (val !== undefined && selectedValueSet.has(val)) {
        selectedChildren.push(child);
      } else {
        otherChildren.push(child);
      }
    });
    this.reorderedChildren = selectedChildren.concat(otherChildren);
    const firstSelectedIndex = selectedChildren.length > 0 ? 0 : -1;
    const initialOffset = firstSelectedIndex >= 0 ? firstSelectedIndex * DefaultItemHeight : 0;

    const wrapperHeight = maxHeight < this.reorderedChildren.length * DefaultItemHeight ?
      maxHeight : this.reorderedChildren.length * DefaultItemHeight;

    return (
      <span className="react-virtualized-list-wrapper">
        <VirtualList
          width="100%"
          height={wrapperHeight + 6}
          scrollOffset={initialOffset}
          itemCount={this.reorderedChildren.length}
          itemSize={this.getItemSize}
          renderItem={this.renderItem}
        />
      </span>
    );
  }
}